import styled from 'styled-components';

export const InsightsListSectionRoot = styled.div`
  height: 100%;
`;

export const Wrapper = styled.div`
  padding: 20px 20px 0 20px;
`;
